import { render, staticRenderFns } from "./FilterDeliveryVehicle.vue?vue&type=template&id=397fb582"
import script from "./FilterDeliveryVehicle.vue?vue&type=script&lang=ts"
export * from "./FilterDeliveryVehicle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports